import {Button, Icon, Paper, Stack, Typography} from "@mui/material";
import {useContext} from "react";
import {SmsPackageDto} from "../../../api/psc";
import {DialogContext} from "../../../contexts/DialogueContext";
import {ThousandSeparator} from "../../../utils/PriceHelper";
import InvoiceTypeDialog from "../dialogs/InvoiceTypeDialog";

export default function SmsPackageItem(props: { item: SmsPackageDto }) {
    const p = props.item;

    const {openDialog} = useContext(DialogContext);

    const handleOpenInvoiceTypeDialog = () => {
        openDialog(<InvoiceTypeDialog packageId={props.item.id}/>)
    }

    return (
        <Paper sx={{p: 1.5}}>
            <Stack direction="column" spacing={1}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Stack spacing={0.5} sx={{flexGrow: 1}}>
                        <Typography sx={{mb: 0.5}}>{p.name}</Typography>
                        <Stack direction="row" spacing={0.5}>
                            <Typography color="text.secondary">قیمت</Typography>
                            <Typography color="primary">
                                {ThousandSeparator(p.price)}
                            </Typography>
                            <Typography color="text.secondary">
                                تومان
                            </Typography>
                        </Stack>
                    </Stack>

                    <Button
                        variant="contained"
                        onClick={handleOpenInvoiceTypeDialog}
                        startIcon={<Icon>shopping_bag</Icon>}
                    >
                        خرید
                    </Button>
                </Stack>
            </Stack>
        </Paper>
    );
}
